import { useEffect } from 'react'

const HelpJuiceChatBot = () => {
  const configScript = document.createElement('script')
  configScript.innerHTML = `
    helpjuice_account_url = 'https://reveni.helpjuice.com';
    helpjuice_contact_us_url = 'https://reveni.helpjuice.com/contact-us';
    helpjuiceSwiftyConfig = {
      subdomain: 'reveni',
      widgetPosition: 'bottomRight',
      themeColor: '#46BD9E',
      linksColor: '#4B99E7',
      chatHeader: 'Reveni Help',
      chatWelcomeHeader: 'Need help?',
      chatWelcomeMessage: 'Let us know what you are looking for!',
      chatInputPlaceholder: 'Ask, write, or search for anything...',
      chatIconUrl: 'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/15869/direct/1761215776972/helpjuiceChatbotIcon.png',
      chatNoResultsMessage: 'Sorry, looks like we couldn\\'t find what you need. Please contact our team via email, they\\'ll be glad to help..'
    };
  `
  configScript.id = 'helpjuice-config-script'
  document.body.appendChild(configScript)

  const chatScript = document.createElement('script')
  chatScript.src = 'https://reveni.helpjuice.com/swifty_chat.js'
  chatScript.async = true
  chatScript.id = 'helpjuice-chat-script'
  document.body.appendChild(chatScript)

  useEffect(() => {
    return () => {
      const config = document.getElementById('helpjuice-config-script')
      const chat = document.getElementById('helpjuice-chat-script')
      if (config) config.remove()
      if (chat) chat.remove()

      const widget = document.querySelector('#swifty-chatbot-container')
      if (widget) widget.remove()
    }
  }, [])

  return null
}

export default HelpJuiceChatBot
